import React from 'react';
import styles from '../../styles/AdmisionEstudiantesStyles/AdmisionEstudiantes.module.css';
import { usePermissions } from '../../hooks/usePermissions';

function StudentTable({ students, onView, onEdit, onDelete }) {
  const { canEdit, canDelete } = usePermissions();
  const puedeEditar = canEdit('Admisiones');
  const puedeEliminar = canDelete('Admisiones');

  const getStatusBadgeClass = (estatus) => {
    switch (estatus) {
      case 'ACTIVO':
        return styles.statusRegular;
      case 'BAJA_TEMPORAL':
        return styles.statusInactive;
      case 'BAJA_DEFINITIVA':
        return styles.statusInactive;
      case 'GRADUADO':
        return styles.statusNew;
      default:
        return styles.statusDefault;
    }
  };

  const getStatusLabel = (estatus) => {
    switch (estatus) {
      case 'ACTIVO':
        return 'Activo';
      case 'BAJA_TEMPORAL':
        return 'Baja Temporal';
      case 'BAJA_DEFINITIVA':
        return 'Baja Definitiva';
      case 'GRADUADO':
        return 'Graduado';
      default:
        return estatus;
    }
  };

  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableSection}>
        <div className={styles.tableSectionHeader}>
          <div className={styles.tableSectionIcon}>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zM4 18v-4h3v4h2v-7.5c0-1.1.9-2 2-2s2 .9 2 2V11h2c1.1 0 2-.9 2-2s-.9-2-2-2H9.5c-.83 0-1.5-.67-1.5-1.5S8.67 4 9.5 4H11c1.1 0 2-.9 2-2s-.9-2-2-2H9.5C7.57 0 6 1.57 6 3.5S7.57 7 9.5 7H11c.28 0 .5.22.5.5s-.22.5-.5.5H9c-2.21 0-4 1.79-4 4V18H4z"/>
            </svg>
          </div>
          <h3 className={styles.tableSectionTitle}>Estudiantes</h3>
          <div className={styles.tablePagination}>
            <span className={styles.paginationInfo}>1 de {students.length}</span>
            <div className={styles.paginationControls}>
              <button className={styles.paginationButton}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M15 18l-6-6 6-6"/>
                </svg>
              </button>
              <button className={styles.paginationButton}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M9 18l6-6-6-6"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
        
        <div className={styles.table}>
          <div className={styles.tableHeader}>
            <div className={styles.headerCell}>
              <span>Nombre</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M7 10l5 5 5-5"/>
              </svg>
            </div>
            <div className={styles.headerCell}>
              <span>Campus</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M7 10l5 5 5-5"/>
              </svg>
            </div>
            <div className={styles.headerCell}>Matrícula</div>
            <div className={styles.headerCell}>
              <span>Programa</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M7 10l5 5 5-5"/>
              </svg>
            </div>
            <div className={styles.headerCell}>
              <span>Estatus</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M7 10l5 5 5-5"/>
              </svg>
            </div>
            <div className={styles.headerCell}>Acciones</div>
          </div>
          
          <div className={styles.tableBody}>
            {students.map((student) => (
              <div key={student.id_estudiante} className={styles.tableRow}>
                <div className={styles.tableCell}>{student.nombre_completo || 'Sin nombre'}</div>
                <div className={styles.tableCell}>{student.campus_nombre || 'Sin campus'}</div>
                <div className={styles.tableCell}>{student.matricula || 'Sin matrícula'}</div>
                <div className={styles.tableCell}>{student.programa_nombre || 'Sin programa'}</div>
                <div className={styles.tableCell}>
                  <span className={`${styles.statusBadge} ${getStatusBadgeClass(student.estatus_estudiante)}`}>
                    {getStatusLabel(student.estatus_estudiante)}
                  </span>
                </div>
                <div className={styles.tableCell}>
                  <div className={styles.actionButtons}>
                    <button 
                      className={styles.actionButton}
                      onClick={() => onView(student.id_estudiante)}
                      title="Ver"
                    >
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    </button>
                    {puedeEditar && (
                    <button 
                      className={styles.actionButton}
                      onClick={() => onEdit(student.id_estudiante)}
                      title="Editar"
                    >
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                      </svg>
                    </button>
                    )}
                    {puedeEliminar && (
                    <button 
                      className={styles.actionButton}
                      onClick={() => onDelete(student.id_estudiante)}
                      title="Eliminar"
                    >
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M3 6h18"/>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                      </svg>
                    </button>
                    )}
                    {!puedeEditar && !puedeEliminar && (
                      <span style={{ color: '#888', fontSize: '12px' }}>Solo lectura</span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentTable;
